import { Card } from "@mui/material";
import CommonLayout from "components/CommonLayout";
import MDBox from "components/MDBox";
import ShowToast from "components/MDToast";
import MDTypography from "components/MDTypography";
import ProductDetail from "components/ProductDetails";
import Loader from "helpers/constants/Loader";
import useTranslation from "hooks/Translation";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useLazyGetProductViewsQuery } from "services/product";
import { useLazyGetProductByIdQuery } from "services/product";

const ProductDetails = () => {
  const navigate = useNavigate();
  const t = useTranslation();
  const { id } = useParams();

  const [productById, { isLoading }] = useLazyGetProductByIdQuery();
  const [productViews] = useLazyGetProductViewsQuery();
  const [productData, setProductData] = useState();
  const [ViewsData, setViewsData] = useState("");
  const getProductDetails = async () => {
    try {
      const res = await productById({ id }).unwrap();
      if (res?.status === 200) {
        setProductData(res?.data);
      }
    } catch (error) {
      console.log(error, "errror");
      ShowToast(error?.data?.message || "", "error");
    }
  };

  const getProductViews = async () => {
    try {
      const res = await productViews({ id }).unwrap();
      if (res?.status === 200) {
        setViewsData(res?.data);
      }
    } catch (error) {
      console.log(error, "errror");
      ShowToast(error?.data?.message || "", "error");
    }
  };

  useEffect(() => {
    getProductDetails();
    getProductViews();
  }, []);

  return (
    <CommonLayout>
      <Card sx={{ marginTop: 10, marginBottom: 10 }}>
        <MDBox
          // variant="gradient"
          bgColor="theme-1"
          borderRadius="lg"
          coloredShadow="success"
          mx={2}
          mt={-3}
          p={3}
          mb={1}
          sx={{ display: "flex", justifyContent: "space-between" }}
          // textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            {t.main.productDetails}
          </MDTypography>

          <MDTypography
            variant="h6"
            color="white"
            mt={1}
            sx={{ cursor: "pointer" }}
            onClick={() => navigate("/product-listing")}
          >
            {t.main.back}
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <ProductDetail productData={productData} ViewsData={ViewsData} />
        </MDBox>
      </Card>
      <Loader loading={isLoading} />
    </CommonLayout>
  );
};

export default ProductDetails;
